angular.module('lead')
    .controller('LeadDialogController', function ($scope, $rootScope, $uibModalInstance, $timeout, $q, data, toastr, Lead, ClientLead, ClientFinderService, LeadService, PhoneNumberFormatter, Principal, LeadReferrerTypes) {
        this.LeadService = LeadService;
        this.LeadReferrerTypes = LeadReferrerTypes;
        this.draftConsentSequence = 0;
        this.referrerFileUpload = {};

        this.prefillConsentsFromSource = () => {
            if (!this.source || this.item.id) {
                return
            }
            this.item.consents = this.item.consents.filter(consent => !isAutoDraftConsent(consent))
            const existingKeys = this.item.consents
                .filter(consent => consent)
                .map(consentKey)
                .reduce((keys, key) => {
                    keys[key] = true
                    return keys
                }, {})

            buildConsentDrafts(this.source).forEach(consent => {
                const key = consentKey(consent)
                if (!existingKeys[key]) {
                    existingKeys[key] = true
                    consent.id = this.nextDraftConsentId()
                    consent.autoDraft = true
                    this.item.consents.push(consent)
                }
            })
        }

        this.nextDraftConsentId = () => 'draft-auto-' + Date.now() + '-' + (++this.draftConsentSequence)

        this.updateConsentLookupContacts = () => this.consentLookupContacts = buildConsentLookupContacts(this.source)

        this.$onInit = () => {
            this.item = data.entity
            this.canViewSourceData = Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_LEADS_ALL'])
            this.canSearchClients = Principal.hasAnyAuthority(['ROLE_CLIENTS_SEARCH'])
            this.canReadLeadClients = Principal.hasAnyAuthority(['ROLE_CLIENTS_READ', 'ROLE_CLIENTS_LEAD_READ'])
            this.canWriteLeadClients = Principal.hasAnyAuthority(['ROLE_CLIENTS_WRITE', 'ROLE_CLIENTS_LEAD_WRITE'])
            this.canSearchLeadClients = this.canSearchClients || Principal.hasAnyAuthority(['ROLE_CLIENTS_LEAD_SEARCH'])
            if (this.item.referrerClient && !this.item.referrerType) {
                this.item.referrerType = this.defaultReferrerType().value
            }
            this.originalReferrerClientId = this.item.referrerClient?.id || null
            this.originalReferrerType = this.item.referrerType || null
            this.originalReferrerFileId = this.item.referrerFile?.id || null
            this.item.managers = this.item.managers || []
            this.leadManager = this.item.managers.length > 0 ? this.item.managers[0] : null
            this.managerCandidates = []
            this.canPickCurrentUserAsManager = false
            this.managerCandidatesPromise = this.item.id ? $q.when([]) : this.loadManagerCandidates()
            this.item.consents = this.item.consents || []
            this.excludeLeadIds = this.item.id ? [this.item.id] : []
            this.originalAcquisitionTime = this.item.acquisitionTime || null
            this.item.acquisitionTimePicker = toTimePickerValue(this.originalAcquisitionTime)
            this.source = normalizeSource(data.suggestion || sourceFromLead(this.item))
            applySourceToItem(this.item, this.source)
            this.updateConsentLookupContacts()
            this.sourceSnapshotPreview = this.canViewSourceData ? buildSourceSnapshotPreview(this.item, this.source) : null
            if (this.canViewSourceData) {
                this.loadSourceSnapshots()
            }
            this.showSourceDetails = false
            this.aiSummaryLoadingMode = null
            this.suggestedClients = []
            this.suggestedClientsCollapsed = !!this.item.client
            this.relatedLeadsCount = null
            this.suggestClientRequestId = 0
            this.managerManuallyChanged = false
            this.prefillConsentsFromSource()
            this.setDefaultLeadManager()
            this.watchLeadContactData()
            this.suggestClient()
        }

        this.suggestClient = () => {
            if (!this.canReadLeadClients) {
                this.suggestedClients = []
                return
            }
            const params = {
                email: normalizeEmailContact(this.source?.email),
                phone: this.source?.phone || null
            }
            const requestId = ++this.suggestClientRequestId
            if (!params.email && !params.phone) {
                this.suggestedClients = []
                return
            }

            this.suggestClientLoading = true
            return ClientLead.suggest(params).$promise
                .then(clients => {
                    if (requestId !== this.suggestClientRequestId) {
                        return
                    }
                    this.suggestedClients = clients || []
                })
                .finally(() => {
                    if (requestId === this.suggestClientRequestId) {
                        this.suggestClientLoading = false
                    }
                })
        }

        this.scheduleSuggestClient = () => {
            this.suggestClientRequestId++
            if (this.suggestClientPromise) {
                $timeout.cancel(this.suggestClientPromise)
            }
            this.suggestClientPromise = $timeout(() => this.suggestClient(), 250)
        }

        this.toggleSuggestedClients = () => this.suggestedClientsCollapsed = !this.suggestedClientsCollapsed

        this.watchLeadContactData = () => {
            if (this.unwatchLeadContactData) {
                this.unwatchLeadContactData()
            }
            this.unwatchLeadContactData = $scope.$watchGroup([
                () => this.source && this.source.email,
                () => this.source && this.source.phone
            ], (current, previous) => {
                if (current === previous || angular.equals(current, previous)) {
                    return
                }
                this.updateConsentLookupContacts()
                this.scheduleSuggestClient()
            })
        }

        this.addClient = (name, email, phone) => {
            if (!this.canWriteLeadClients) {
                return $q.when()
            }
            let normalizedPhone = PhoneNumberFormatter.normalizeForCompare(phone) || phone
            return ClientFinderService.edit({fullName: name, contacts: buildClientContacts(email, normalizedPhone)}).then((client) => this.onClientSelected(client))
        }

        this.addClientFromSource = () => this.addClient(this.source.name, this.source.email, this.source.phone)
        this.hasMissingSourcePhoneInClient = () => canAddSourcePhone(this.source, this.item.client)
        this.hasMissingSourceEmailInClient = () => canAddSourceEmail(this.source, this.item.client)
        this.hasSourceSyncData = () => this.item.client && (this.hasMissingSourcePhoneInClient() || this.hasMissingSourceEmailInClient())
        this.editClientWithSourceData = () => {
            if (!this.hasSourceSyncData() || !this.canWriteLeadClients) {
                return
            }
            const clientId = getClientId(this.item.client)
            if (!clientId) {
                return
            }
            return ClientLead.get({id: clientId}).$promise
                .then(client => ClientFinderService.edit(client, {
                    sourceSync: buildSourceSyncOptions(this.source, this.item.client),
                    beforeOpen: editedClient => applySourceDefaultsToClient(editedClient, this.source)
                }))
                .then(client => {
                    this.onClientSelected(client)
                    return this.suggestClient()
                })
        }
        this.toggleSourceDetails = () => this.showSourceDetails = !this.showSourceDetails
        this.showClientSearch = () => this.clientSearchVisible = this.canSearchLeadClients
        this.hideClientSearch = () => {
            this.clientSearchVisible = false
            if (!this.item.client) {
                delete this.item.client
            }
        }

        this.onSourceChange = () => {
            applySourceToItem(this.item, this.source)
            this.updateConsentLookupContacts()
            this.relatedLeadsCount = null
            this.sourceSnapshotPreview = this.canViewSourceData ? buildSourceSnapshotPreview(this.item, this.source) : null
            this.prefillConsentsFromSource()
            this.scheduleSuggestClient()
            this.resetRelatedManagerWhenLookupUnavailable()
        }

        this.onAcquisitionDateChange = () => {
            if (!this.item.acquisitionDate) {
                this.item.acquisitionTimePicker = toTimePickerValue(this.originalAcquisitionTime)
                return
            }
            if (this.item.acquisitionTimePicker) {
                return
            }
            this.item.acquisitionTimePicker = currentTimePickerValue()
        }

        this.summarizeSourceMessage = (mode) => {
            if (!this.source || !this.source.notes) {
                toastr.error("Brak wiadomości do skrócenia");
                return;
            }
            this.aiSummaryLoadingMode = mode
            return Lead.summarizeSourceMessage({
                notes: this.source.notes,
                request: this.source.request,
                propertyProject: this.source.property_project,
                propertyNumber: this.source.property_number,
                sourceName: this.source.name,
                sourcePhone: this.source.phone,
                sourceEmail: this.source.email,
                mode: mode
            }).$promise.then(result => {
                let summary = result.summary ? result.summary.trim() : null
                if (!summary) {
                    toastr.error("AI nie zwróciło skrótu");
                    return;
                }
                this.item.notes = mergeSummaryIntoNotes(this.item.notes, summary)
                toastr.success("Dodano skrót AI do notatek");
            }).catch(rejection => {
                toastr.error(rejection?.data?.message || "Nie udało się przygotować skrótu AI");
            }).finally(() => this.aiSummaryLoadingMode = null)
        }

        this.summarizeLeadNotes = (mode) => {
            if (!this.item || !this.item.notes) {
                toastr.error("Brak uwag do skrócenia");
                return;
            }
            this.aiSummaryLoadingMode = mode
            return Lead.summarizeSourceMessage({
                notes: this.item.notes,
                request: this.item.acquisitionSource?.name,
                sourceName: this.item.sourceName,
                sourcePhone: this.item.sourcePhone,
                sourceEmail: this.item.sourceEmail,
                mode: mode
            }).$promise.then(result => {
                let summary = result.summary ? result.summary.trim() : null
                if (!summary) {
                    toastr.error("AI nie zwróciło skrótu");
                    return;
                }
                this.item.notes = summary
                toastr.success("Zaktualizowano uwagi skrótem AI");
            }).catch(rejection => {
                toastr.error(rejection?.data?.message || "Nie udało się przygotować skrótu AI");
            }).finally(() => this.aiSummaryLoadingMode = null)
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            applySourceToItem(this.item, this.source)
            this.saveStep = this.referrerFileUpload.hasPendingFile?.() ? 'FILE_UPLOAD' : 'LEAD_SAVE'
            return this.uploadReferrerFileIfNeeded()
                .then(referrerFile => {
                    this.saveStep = 'LEAD_SAVE'
                    let payload = angular.copy(this.item)
                    payload.acquisitionTime = toApiTimeValue(this.item.acquisitionTimePicker)
                    payload.consents = (payload.consents || []).map(toLeadConsentForm)
                    payload.referrerFileId = this.isReferrerAttachmentEnabled() && referrerFile ? referrerFile.id : null
                    delete payload.acquisitionTimePicker
                    delete payload.referrerFile
                    return this.item.id !== null
                        ? Lead.update(payload).$promise
                        : Lead.save(payload).$promise
                })
                .then(result => {
                    $rootScope.$broadcast('lead.updated')
                    $uibModalInstance.close(result)
                })
                .finally(() => this.saveStep = null)
        }

        this.defaultReferrerType = () => LeadReferrerTypes.find(type => type.default) || LeadReferrerTypes[0]
        this.getReferrerType = value => LeadReferrerTypes.find(type => type.value === value) || this.defaultReferrerType()
        this.currentReferrerType = () => this.getReferrerType(this.item.referrerType)
        this.isReferrerAttachmentEnabled = () => !!this.item.referrerClient
            && this.currentReferrerType().fileRequired

        this.isUnchangedLegacyReferrer = () => !!this.item.id
            && this.originalReferrerFileId == null
            && this.originalReferrerClientId === (this.item.referrerClient?.id || null)
            && this.getReferrerType(this.originalReferrerType).value === this.currentReferrerType().value

        this.isReferrerAttachmentRequired = () => this.isReferrerAttachmentEnabled()
            && !this.isUnchangedLegacyReferrer()

        this.uploadReferrerFileIfNeeded = () => {
            if (!this.isReferrerAttachmentEnabled()) {
                return $q.resolve(null)
            }
            if (!angular.isFunction(this.referrerFileUpload.upload)) {
                return $q.resolve(this.item.referrerFile || null)
            }
            return this.referrerFileUpload.upload()
        }

        this.clearReferrerFile = () => {
            if (angular.isFunction(this.referrerFileUpload.clear)) {
                this.referrerFileUpload.clear()
                return
            }
            delete this.item.referrerFile
        }

        this.onClientSelected = (value) => {
            if (value) {
                this.item.client = value
                this.suggestedClientsCollapsed = true
                this.relatedLeadsCount = null
                this.updateConsentLookupContacts()
            } else {
                delete this.item.client
                this.suggestedClientsCollapsed = false
                this.relatedLeadsCount = null
                this.updateConsentLookupContacts()
                this.suggestClient()
                this.resetRelatedManagerWhenLookupUnavailable()
            }
        }
        this.onManagerSelected = user => {
            if (user && !this.isManagerCandidate(user)) {
                return
            }
            this.managerManuallyChanged = true
            this.setLeadManager(user, false)
        }
        this.setLeadManager = (user, autoAssigned) => {
            this.leadManager = user || null
            this.item.managers = user ? [user] : []
            this.managerAutoAssigned = autoAssigned === true
        }
        this.currentUser = () => {
            this.currentUserPromise = this.currentUserPromise || Principal.currentUser()
            return this.currentUserPromise
        }
        this.isManagerCandidate = user => !!(user && this.managerCandidates.some(candidate => candidate.id === user.id))
        this.loadManagerCandidates = () => Lead.managerCandidates().$promise
            .then(items => {
                this.managerCandidates = items || []
                if (!this.item.id && this.leadManager && !this.isManagerCandidate(this.leadManager)) {
                    this.setLeadManager(null, false)
                }
                return this.currentUser()
            })
            .then(user => this.canPickCurrentUserAsManager = this.isManagerCandidate(user))
        this.setDefaultLeadManager = () => {
            if (this.item.id || this.managerManuallyChanged || this.item.managers.length > 0) {
                return
            }
            return this.managerCandidatesPromise.then(() => this.currentUser()).then(user => {
                if (!this.isManagerCandidate(user) || this.item.id || this.managerManuallyChanged || this.item.managers.length > 0) {
                    return
                }
                this.setLeadManager(user, true)
            })
        }
        this.replaceInactiveManagerWithCurrentUser = () => {
            const managerBeforeRequest = this.leadManager
            return this.managerCandidatesPromise.then(() => this.currentUser()).then(user => {
                if (!this.isManagerCandidate(user) || this.item.id || this.managerManuallyChanged || this.leadManager !== managerBeforeRequest) {
                    return
                }
                this.setLeadManager(user, true)
            })
        }
        this.resetRelatedManagerWhenLookupUnavailable = () => {
            if (this.hasRelatedLeadsLookup() || this.item.id || this.managerManuallyChanged || !this.managerAutoAssigned) {
                return
            }
            this.setLeadManager(null, false)
            this.setDefaultLeadManager()
        }
        this.onRelatedLeadsLoaded = page => {
            this.relatedLeadsCount = page ? page.fullListSize || 0 : 0
            return this.managerCandidatesPromise.then(() => this.applyRelatedLeadManager(page))
        }
        this.applyRelatedLeadManager = page => {
            if (this.item.id || this.managerManuallyChanged) {
                return
            }
            const relatedLeads = page && page.list ? page.list : []
            const sourceLead = relatedLeads[0]
            if (!sourceLead || !sourceLead.managers || sourceLead.managers.length === 0) {
                if (this.managerAutoAssigned) {
                    this.setLeadManager(null, false)
                    this.setDefaultLeadManager()
                }
                return
            }
            if (this.item.managers.length > 0 && !this.managerAutoAssigned) {
                return
            }
            const sourceManager = sourceLead.managers[0]
            if (!this.isManagerCandidate(sourceManager)) {
                return this.replaceInactiveManagerWithCurrentUser()
            }
            this.setLeadManager(sourceManager, true)
        }
        this.onReferrerSelected = (value) => {
            if (!this.canSearchClients) {
                return
            }
            if (value) {
                this.item.referrerClient = value
                this.item.referrerType = this.item.referrerType || this.defaultReferrerType().value
            } else {
                this.clearReferrer()
            }
        }
        this.enableReferrerForm = () => {
            if (!this.canSearchClients) {
                return
            }
            this.referrerForm = true
            this.item.referrerType = this.item.referrerType || this.defaultReferrerType().value
        }
        this.disableReferrerForm = () => {
            delete this.referrerForm
            this.clearReferrer()
        }
        this.clearReferrer = () => {
            delete this.item.referrerClient
            delete this.item.referrerType
            this.clearReferrerFile()
        }

        this.hasPhoneMismatch = (sourcePhone, clientPhone) => {
            let normalizedSourcePhone = PhoneNumberFormatter.normalizeForCompare(sourcePhone)
            let normalizedClientPhone = PhoneNumberFormatter.normalizeForCompare(clientPhone)
            return !!normalizedSourcePhone && !!normalizedClientPhone && normalizedSourcePhone !== normalizedClientPhone
        }
        this.hasSourceData = () => !!(
            this.item.sourceName
            || this.item.sourcePhone
            || this.item.sourceEmail
            || this.item.sourceRequest
            || this.item.sourceMessage
            || this.item.sourceProject
            || this.item.sourcePropertyNumber
            || this.item.acquisitionDate
            || this.item.acquisitionTimePicker
        )
        this.hasSourceTab = () => !!(
            this.hasRelatedLeadsLookup()
            || (this.canViewSourceData && (this.item.id || (this.sourceSnapshotPreview && this.sourceSnapshotPreview.formattedPayloadJson)))
        )
        this.hasRelatedLeadsLookup = () => !!(
            this.source.email
            || this.source.phone
            || getClientId(this.item.client)
        )
        this.formatAcquisitionTime = () => {
            if (!this.item.acquisitionTimePicker) {
                return null
            }
            return moment.isMoment(this.item.acquisitionTimePicker)
                ? this.item.acquisitionTimePicker.format('HH:mm')
                : this.item.acquisitionTimePicker
        }

        this.loadSourceSnapshots = () => {
            if (!this.canViewSourceData || !this.item.id) {
                this.sourceSnapshots = []
                return
            }
            this.sourceSnapshotsPromise = Lead.sourceSnapshots({id: this.item.id}).$promise.then(items => {
                this.sourceSnapshots = (items || []).map(item => {
                    item.formattedPayloadJson = formatSnapshotJson(item)
                    return item
                })
            })
        }

        function toTimePickerValue(value) {
            if (!value) {
                return null
            }
            let parsed = moment(value, ['HH:mm:ss', 'HH:mm'], true)
            return parsed.isValid() ? parsed : null
        }

        function toApiTimeValue(value) {
            if (!value) {
                return null
            }
            let parsed
            if (moment.isMoment(value)) {
                parsed = value
            } else if (angular.isDate(value)) {
                parsed = moment(value)
            } else {
                parsed = moment(String(value).trim(), ['HH:mm:ss', 'HH:mm'], true)
            }
            if (!parsed.isValid()) {
                return null
            }
            return parsed.clone().seconds(0).milliseconds(0).format('HH:mm:ss')
        }

        function currentTimePickerValue() {
            return moment().seconds(0).milliseconds(0)
        }

        function mergeSummaryIntoNotes(notes, summary) {
            if (!notes) {
                return summary
            }
            let trimmedNotes = notes.trim()
            if (!trimmedNotes) {
                return summary
            }
            return trimmedNotes.includes(summary) ? trimmedNotes : `${trimmedNotes}\n\n${summary}`
        }

        function hasSourceDetails(source) {
            return !!(source && (source.request || source.property_project || source.property_number || source.notes))
        }

        function normalizeSource(source) {
            source = source || {}
            return {
                name: source.name || null,
                email: source.email || null,
                phone: source.phone || null,
                request: source.request || source.source || null,
                notes: source.notes || source.message || null,
                property_project: source.property_project || source.project || null,
                property_number: source.property_number || source.product || source.unit || null,
                privacy_policy: source.privacy_policy,
                privacy_policy_text: source.privacy_policy_text,
                personal_data_processing: source.personal_data_processing,
                personal_data_processing_text: source.personal_data_processing_text,
                receiving_commercials: source.receiving_commercials,
                receiving_commercials_text: source.receiving_commercials_text,
                profiling_personal_data_for_marketing: source.profiling_personal_data_for_marketing,
                profiling_personal_data_for_marketing_text: source.profiling_personal_data_for_marketing_text,
                direct_marketing_using_telco_equipment: source.direct_marketing_using_telco_equipment,
                direct_marketing_using_telco_equipment_text: source.direct_marketing_using_telco_equipment_text,
                receipt_of_commercial_information: source.receipt_of_commercial_information,
                receipt_of_commercial_information_text: source.receipt_of_commercial_information_text,
                rawPayload: source.rawPayload || source.raw_payload || source.payload || null
            }
        }

        function normalizeText(value) {
            return value == null ? '' : String(value).trim()
        }

        function sourceFromLead(lead) {
            return {
                name: lead.sourceName,
                email: lead.sourceEmail,
                phone: lead.sourcePhone,
                request: lead.sourceRequest,
                notes: lead.sourceMessage,
                property_project: lead.sourceProject,
                property_number: lead.sourcePropertyNumber
            }
        }

        function applySourceToItem(item, source) {
            if (!source) {
                return
            }
            item.sourceName = source.name || null
            item.sourceEmail = source.email || null
            item.sourcePhone = source.phone || null
            item.sourceRequest = source.request || null
            item.sourceMessage = source.notes || null
            item.sourceProject = source.property_project || null
            item.sourcePropertyNumber = source.property_number || null
        }

        function applySourceDefaultsToClient(client, source) {
            if (!client || !source) {
                return
            }
            client.contacts = client.contacts || []
            if (canAddSourcePhone(source, client)) {
                client.contacts.push({type: 'PHONE', value: normalizePhoneContact(source.phone) || source.phone, active: true, defaults: false})
            }
            if (canAddSourceEmail(source, client)) {
                client.contacts.push({type: 'EMAIL', value: normalizeEmailContact(source.email) || source.email, active: true, defaults: false})
            }
            if (!normalizeText(client.fullName) && normalizeText(source.name)) {
                client.fullName = normalizeText(source.name)
            }
        }

        function buildSourceSyncOptions(source, client) {
            return {
                sourceName: normalizeText(source && source.name),
                clientName: normalizeText(client && client.fullName),
                nameDifferent: hasDifferentSourceNameInClient(source, client)
            }
        }

        function canAddSourcePhone(source, client) {
            const sourcePhone = PhoneNumberFormatter.normalizeForCompare(source && source.phone)
            if (!sourcePhone || !client) {
                return false
            }
            return !((client.contacts || []).some(contact => {
                const clientPhone = contact && contact.type === 'PHONE' ? PhoneNumberFormatter.normalizeForCompare(contact.value) : null
                return !!clientPhone && clientPhone === sourcePhone
            }))
        }

        function canAddSourceEmail(source, client) {
            const sourceEmail = normalizeEmailContact(source && source.email)
            if (!sourceEmail || !client) {
                return false
            }
            return !((client.contacts || []).some(contact => contact && contact.type === 'EMAIL' && normalizeEmailContact(contact.value) === sourceEmail))
        }

        function hasDifferentSourceNameInClient(source, client) {
            const sourceName = normalizeText(source && source.name)
            const clientName = normalizeText(client && client.fullName)
            return !!sourceName && !!clientName && normalizeName(sourceName) !== normalizeName(clientName)
        }

        function normalizeName(value) {
            return normalizeText(value).replace(/\s+/g, ' ').toLowerCase()
        }

        function getClientId(client) {
            return client && (client.id || client.clientId)
        }

        function buildSourceSnapshotPreview(item, source) {
            const rawPayload = source?.rawPayload || null
            if (!rawPayload) {
                return null
            }
            return {
                sourceSystem: item.externalSource?.system || 'FORMULARZ',
                externalId: item.externalSource?.id || null,
                formattedPayloadJson: formatJson(rawPayload)
            }
        }

        function formatJson(value) {
            if (!value) {
                return ""
            }
            try {
                return JSON.stringify(removeNullValues(value), null, 2)
            } catch (e) {
                return String(value)
            }
        }

        function formatSnapshotJson(snapshot) {
            const value = snapshot && snapshot.payloadJson
            if (!value) {
                return ""
            }
            try {
                const data = JSON.parse(value)
                if (angular.isObject(data) && data.id == null && snapshot.externalId != null) {
                    data.id = snapshot.externalId
                }
                return JSON.stringify(removeNullValues(data), null, 2)
            } catch (e) {
                return value
            }
        }

        function removeNullValues(value) {
            if (angular.isArray(value)) {
                return value.map(removeNullValues)
            }
            if (!angular.isObject(value) || value instanceof Date) {
                return value
            }
            return Object.keys(value).reduce((result, key) => {
                const item = value[key]
                if (item === null || angular.isUndefined(item)) {
                    return result
                }
                result[key] = removeNullValues(item)
                return result
            }, {})
        }

        function buildConsentDrafts(source) {
            const consents = []
            const email = normalizeEmailContact(source.email)
            const phone = normalizePhoneContact(source.phone)

            if (isGranted(source.privacy_policy)) {
                const text = source.privacy_policy_text || 'Zapoznanie z polityką prywatności'
                addConsent(consents, email, 'EMAIL', 'PRIVACY_POLICY_ACK', text)
                addConsent(consents, phone, 'PHONE', 'PRIVACY_POLICY_ACK', text)
            }

            if (isGranted(source.personal_data_processing)) {
                const text = source.personal_data_processing_text || 'Przetwarzanie danych'
                addConsent(consents, email, 'EMAIL', 'DATA_PROCESSING_INFO_ACK', text)
                addConsent(consents, phone, 'PHONE', 'DATA_PROCESSING_INFO_ACK', text)
            }

            addMarketingConsent(consents, email, 'EMAIL', source.receiving_commercials, source.receiving_commercials_text, 'Zgoda na otrzymywanie informacji handlowych')
            addMarketingConsent(consents, phone, 'PHONE', source.profiling_personal_data_for_marketing, source.profiling_personal_data_for_marketing_text, 'Zgoda na marketing telefoniczny')
            addMarketingConsent(consents, email, 'EMAIL', source.direct_marketing_using_telco_equipment, source.direct_marketing_using_telco_equipment_text, 'Zgoda na marketing przy użyciu urządzeń telekomunikacyjnych')
            addMarketingConsent(consents, phone, 'PHONE', source.direct_marketing_using_telco_equipment, source.direct_marketing_using_telco_equipment_text, 'Zgoda na marketing przy użyciu urządzeń telekomunikacyjnych')
            addMarketingConsent(consents, phone, 'SMS', source.direct_marketing_using_telco_equipment, source.direct_marketing_using_telco_equipment_text, 'Zgoda na marketing przy użyciu urządzeń telekomunikacyjnych')
            addMarketingConsent(consents, email, 'EMAIL', source.receipt_of_commercial_information, source.receipt_of_commercial_information_text, 'Zgoda na otrzymywanie informacji handlowych')
            addMarketingConsent(consents, phone, 'SMS', source.receipt_of_commercial_information, source.receipt_of_commercial_information_text, 'Zgoda na otrzymywanie informacji handlowych')

            return consents
        }

        function buildConsentLookupContacts(source) {
            const contacts = []
            addLookupContact(contacts, normalizeEmailContact(source && source.email))
            addLookupContact(contacts, normalizePhoneContact(source && source.phone))
            addLookupContact(contacts, fallbackPhoneLookupContact(source && source.phone))
            return contacts
        }

        function addLookupContact(contacts, value) {
            if (!value || contacts.indexOf(value) >= 0) {
                return
            }
            contacts.push(value)
        }

        function fallbackPhoneLookupContact(value) {
            if (!value || String(value).includes('@')) {
                return null
            }
            const contact = String(value).trim()
            const compact = contact.replace(/[^0-9+]/g, '')
            return /^(\+|00)?[0-9]{7,15}$/.test(compact) ? contact : null
        }

        function addMarketingConsent(consents, contact, channel, granted, text, fallback) {
            if (isGranted(granted)) {
                addConsent(consents, contact, channel, 'MARKETING', text || fallback)
            }
        }

        function addConsent(consents, contact, channel, purpose, consentText) {
            if (!contact) {
                return
            }
            const key = consentKey({contact: contact, channel: channel, purpose: purpose})
            if (consents.some(item => item._key === key)) {
                return
            }
            consents.push({
                id: null,
                draftOrder: Date.now() + consents.length,
                _key: key,
                contact: contact,
                channel: channel,
                purpose: purpose,
                status: 'GRANTED',
                consentText: consentText || null,
                grantedAt: new Date()
            })
        }

        function isAutoDraftConsent(consent) {
            return !!(consent && (consent.autoDraft || String(consent.id || '').indexOf('draft-auto-') === 0))
        }

        function consentKey(consent) {
            return [String(consent.contact || '').trim().toLowerCase(), consent.channel, consent.purpose].join('|')
        }

        function normalizeEmailContact(value) {
            if (!value) {
                return null
            }
            const email = String(value).trim().toLowerCase()
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : null
        }

        function buildClientContacts(email, phone) {
            const contacts = []
            if (phone) {
                contacts.push({type: 'PHONE', value: phone, name: 'Telefon', active: true, defaults: true})
            }
            if (email) {
                contacts.push({type: 'EMAIL', value: email, name: 'Email', active: true, defaults: contacts.length === 0})
            }
            return contacts
        }

        function normalizePhoneContact(value) {
            if (!value || String(value).includes('@')) {
                return null
            }
            const normalized = PhoneNumberFormatter.normalizeForCompare(value)
            return normalized && normalized.indexOf('+') === 0 ? normalized : null
        }

        function isGranted(value) {
            return value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'true'
        }

        function toLeadConsentForm(consent) {
            const channel = consent.channel
            const contact = channel === 'PHONE' || channel === 'SMS'
                ? normalizePhoneContact(consent.contact)
                : channel === 'EMAIL'
                    ? normalizeEmailContact(consent.contact)
                    : consent.contact
            return {
                contact: contact,
                channel: channel,
                purpose: consent.purpose,
                status: consent.status,
                consentText: consent.consentText || null,
                gdprSourceId: consent.gdprSourceId || consent.gdprSource?.id || null,
                withdrawalMethodId: consent.withdrawalMethodId || consent.withdrawalMethod?.id || null
            }
        }
    })
